import { Box, Grid, Typography } from "@mui/material";
import { useStyles } from "./styles";
import { CustomPaper } from "../../../../../../../../components/CustomPaper";
import { useTranslation } from "react-i18next";
import { TimerCounterSla } from "../timerCounter";
import { FolioType } from "../../../../utils/enums/folioType";
import { ChipDaysTranscurredSla } from "../chipDaysTranscurred";
import { FinalBoxDaysTranscurredSla } from "../finalBox";
import { TimesTypes } from "../../../../../../../../utils/enums/times";
import { TimerCounterOla } from "../timeCounterOla";
import { DaysTranscurredProps } from "./types";
import { ChipDaysOla } from "../chipDaysOla";
import { FinalBoxOla } from "../finalOlaBox";


export const DaysTranscurredSla = ({ title, type, startDate, endDate, isNull, timeConfig, finishDate, timeType, timer, datesArray }: DaysTranscurredProps) => {

  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <CustomPaper elevation={3} sx={styles.flex}>
      <Grid container sx={styles.gridContainer} spacing={2}>
        <Grid item xs={(type == FolioType.PREVENTIVE || timeType == TimesTypes.OLA) ? 1.54 : 2.54} sx={{ textAlign: 'center' }}>
          <Typography color="textSecondary" variant="big" sx={styles.bold}>{title}</Typography>
        </Grid>
        <Grid item xs={(type == FolioType.PREVENTIVE || timeType == TimesTypes.OLA) ? 4 : 5}>
          {timeType == TimesTypes.SLA ?
            <ChipDaysTranscurredSla finishDate={finishDate} isNull={isNull} children={<TimerCounterSla finishDate={finishDate} startDate={startDate} daysReturn />} startDate={startDate} timeConfig={timeConfig} />
            :
            <ChipDaysOla startDate={datesArray} timer={timer} isNull={isNull} children={<TimerCounterOla timer={timer} startDate={datesArray} timeConfig={timeConfig} daysReturn isStart />} timeConfig={timeConfig} />
          }
        </Grid>
        <Grid item xs={(type == FolioType.PREVENTIVE || timeType == TimesTypes.OLA) ? 3.46 : 4.46}>
          <Box>
            {isNull ?
              <Typography color="textSecondary" sx={styles.bold}>00:00:00</Typography>
              :
              (
                <>
                  {timeType == TimesTypes.SLA ?
                    <TimerCounterSla finishDate={finishDate} startDate={startDate} daysReturn={false} />
                    :
                    <TimerCounterOla timer={timer} startDate={datesArray} timeConfig={timeConfig} daysReturn={false} isStart />
                  }
                </>
              )
            }
            <Typography color="textSecondary" sx={styles.sizeText}>{t('reportFolio.detail.general.timeConsumed')}</Typography>
          </Box>
        </Grid>
        {(type == FolioType.PREVENTIVE || timeType == TimesTypes.OLA) &&
          <Grid item xs={3}>
            <Box>
              {isNull ?
                <Typography color="textSecondary" sx={styles.bold}>00:00:00</Typography>
                :
                (
                  <>
                    {timeType == TimesTypes.SLA ?
                      <TimerCounterSla finishDate={finishDate} startDate={startDate} endDate={endDate} daysReturn={false} />
                      :
                      <TimerCounterOla timer={timer} startDate={datesArray} timeConfig={timeConfig} daysReturn={false} isStart={false} />
                    }
                  </>
                )
              }
              <Typography color="textSecondary" sx={styles.sizeText}>{t('reportFolio.detail.general.remainingTime')}</Typography>
            </Box>
          </Grid>
        }
      </Grid>
      {timeType == TimesTypes.SLA ?
        <FinalBoxDaysTranscurredSla finishDate={finishDate} startDate={startDate} timeConfig={timeConfig} />
        :
        <FinalBoxOla startDate={datesArray} timer={timer} timeConfig={timeConfig} />
      }

    </CustomPaper>
  );
};
